import { Component, Injector, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { FaqService } from '../../../_services/faq.service';
import { LanguageService } from '../../../_services/language.service';
import { LanguageReadDto } from '../../../_models/languageReadDto';
import { Global } from 'src/app/_services/global.service';

@Component({
  selector: 'app-faq-addnew',
  templateUrl: './faq.update.component.html',
  styleUrls: ['../faq.component.scss']

})

export class FaqUpdateComponent implements OnInit {
  data = false;
  faqUpdate: any;
  getdata: any;
  id: string;
  languageList: LanguageReadDto[];
  @Input() public itemId;
  readonly typeList = [ 'MmitaWeb', 'Partner']


  constructor(
    private formbulider: FormBuilder,
    private faqService: FaqService,
    private languageService: LanguageService,
    private injector: Injector,
    private global: Global,
    private toastr: ToastrService
  ) {
    this.fetchLanguageAll();
  }

  ngOnInit() {
    this.id = this.itemId; // this.route.snapshot.params['id'];
    this.faqUpdate = this.formbulider.group({
      Order: ['', [Validators.required]],
      Question: ['', [Validators.required]],
      Answer: ['', [Validators.required]],
      LanguageCode: ['', [Validators.required]],
      type: ['', [Validators.required]],

    });

    this.faqService.getById(this.id)
        .pipe(first())
     .subscribe(x => {
       this.getdata = x;
     });
  }
  fetchLanguageAll() {
    this.languageService.apiLanguageGet()
      .pipe(first())
      .subscribe(
        data => {
          this.languageList = data.filter(t => t.isActive).sort(t => t.order);
        });
  }
  onFaqUpdateFormSubmit() {
    const useredit = this.faqUpdate.value;
    this.faqService.updateById(useredit, this.getdata.id)
      .pipe(first())
      .subscribe(
        data => {
          this.modalClose();
          this.global.appEvent.next({ msg: 'reload.faq', para: null });
          this.toastr.success('Data Updated Successfully...!', 'Success');
        });
  }
  modalClose() {
    this.global.appEvent.next({ msg: 'modalService.close', para: null });

  }

}
